import { render, staticRenderFns } from "./sub2.vue?vue&type=template&id=44b5413c&lang=pug&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44b5413c')) {
      api.createRecord('44b5413c', component.options)
    } else {
      api.reload('44b5413c', component.options)
    }
    module.hot.accept("./sub2.vue?vue&type=template&id=44b5413c&lang=pug&", function () {
      api.rerender('44b5413c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sample/sample/sub2.vue"
export default component.exports